//#region ../../packages/components/form/src/constants.ts
const formContextKey = Symbol("formContextKey");
const formItemContextKey = Symbol("formItemContextKey");

//#endregion
export { formContextKey, formItemContextKey };
//# sourceMappingURL=constants.mjs.map